var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _EventEmitter_listeners;
export function urlJoin(...paths) {
    if (paths.length === 0) {
        return "/";
    }
    const [s, ...ps] = paths;
    let fullpath = s !== null && s !== void 0 ? s : "/";
    for (let p of ps) {
        fullpath = fullpath.replace(/(\/+)$/, "");
        fullpath = fullpath + "/" + p.replace(/^(\/)/, "");
    }
    return fullpath;
}
/**
 * Naive implementation of the EventEmitter
 */
export class EventEmitter {
    constructor() {
        _EventEmitter_listeners.set(this, void 0);
        __classPrivateFieldSet(this, _EventEmitter_listeners, new Map(), "f");
    }
    addEventListener(eventName, handler) {
        let v = __classPrivateFieldGet(this, _EventEmitter_listeners, "f").get(eventName);
        if (v === undefined) {
            v = new Map();
            __classPrivateFieldGet(this, _EventEmitter_listeners, "f").set(eventName, v);
        }
        const ref = new WeakRef(handler);
        v.set(ref, handler);
        return () => {
            const v = __classPrivateFieldGet(this, _EventEmitter_listeners, "f").get(eventName);
            if (v) {
                v.delete(ref);
            }
        };
    }
    removeListeners(eventName) {
        __classPrivateFieldGet(this, _EventEmitter_listeners, "f").delete(eventName);
    }
    removeAllListeners() {
        __classPrivateFieldGet(this, _EventEmitter_listeners, "f").clear();
    }
    emit(eventName, ...args) {
        var _a, _b;
        const vals = (_b = (_a = __classPrivateFieldGet(this, _EventEmitter_listeners, "f").get(eventName)) === null || _a === void 0 ? void 0 : _a.entries()) !== null && _b !== void 0 ? _b : [];
        for (let [_, fn] of vals) {
            fn(...args);
        }
    }
}
_EventEmitter_listeners = new WeakMap();
class InvariantError extends Error {
    constructor(...args) {
        super(...args);
        this.name = "InvariantError";
    }
}
export function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message || "Assertion failed");
    }
}
/**
 * Extends the standard URL class to allow chaining of paths
 * using the `joinPath` method.
 */
export class JURL extends URL {
    /**
     * Joins one or more path segments onto the current URL,
     * returning a new ChainableURL instance.
     * @param paths - Path segments to append
     * @returns A new ChainableURL with the joined path
     */
    joinPath(...paths) {
        const newurl = new JURL(this);
        newurl.pathname = urlJoin(this.pathname, ...paths);
        return newurl;
    }
}
